import { FIELD_TYPES } from "constants/template-field-type";
import { HEADER_POPUP_OPTIONS } from "constants/header-popup";

import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "",
  fields: {
    ...SharedAdvancedFieldsConfig,
    logoPopup: {
      type: FIELD_TYPES.COMBO,
      label: "Logo Popup",
      options: HEADER_POPUP_OPTIONS
    },
    mobileStickySignup: { type: FIELD_TYPES.BOOLEAN, label: "Mobile sticky signup (In test don't touch)" },
    mobileDarkHeader: { type: FIELD_TYPES.BOOLEAN, label: "Mobile dark header (In test don't touch)" },
    simulateBrandCampaign: { type: FIELD_TYPES.BOOLEAN, label: "In Test - DON'T USE - Simulate Brand Campaign" },
    headerWithoutProjects: { type: FIELD_TYPES.BOOLEAN, label: "In Test - DON'T USE - Header without projects" }
  }
};
